import axios from 'axios';

// URL này trỏ đến backend của bạn
const API_URL = 'https://nghean.06.io.vn/api';

const api = axios.create({
  baseURL: API_URL
});

// (Giữ nguyên) Tự động đính kèm token vào header của mọi yêu cầu
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// (MỚI - Giải quyết Vấn đề 1)
// Bắt lỗi 401 (Token hết hạn / Không hợp lệ)
api.interceptors.response.use(
  (response) => {
    // Nếu request thành công, trả về response
    return response;
  }, 
  (error) => {
    // Nếu request thất bại
    if (error.response && error.response.status === 401) {
      // Nếu lỗi là 401 (Unauthorized)
      console.log('Token hết hạn hoặc không hợp lệ. Đang đăng xuất...');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Tải lại trang (để đưa về trang Login)
      window.location.href = '/login';
    }
    // Trả về lỗi
    return Promise.reject(error);
  }
);

export default api;
